import request from "./../utils/request";

export const AUTOMATION_API = {
    listAutomations: async (filters, cursor, sort) => {
        return request
            .post(
                "/automation/list",
                { filters, cursor, sort },
                {
                    timeout: 60 * 1000 * 5,
                }
            )
            .then((response) => response.data);
    },
    findAutomationById: async (id) => {
        return request
            .get(`/automation/${id}`, {
                timeout: 60 * 1000 * 5,
            })
            .then((response) => response.data);
    },
    createAutomation: async (name, options, diagram, reference, targetContactFilter) => {
        return request
            .put(
                "/automation",
                { name, options, diagram, reference, targetContactFilter },
                {
                    timeout: 60 * 1000,
                }
            )
            .then((response) => response.data);
    },
    createEmptyTimerAutomation: async () => {
        return request
            .put(
                "/automation/empty-timer-automation",
                {},
                {
                    timeout: 60 * 1000,
                }
            )
            .then((response) => response.data);
    },
    createEmptyEventAutomation: async (name, event, payload, reference) => {
        return request
            .put(
                "/automation/empty-event-automation",
                {
                    name,
                    event,
                    payload,
                    reference,
                },
                {
                    timeout: 60 * 1000,
                }
            )
            .then((response) => response.data);
    },
    createWebhookAutomation: async (name, payload) => {
        return request
            .put(
                "/automation/webhook-automation",
                {
                    name,
                    payload,
                },
                {
                    timeout: 60 * 1000,
                }
            )
            .then((response) => response.data);
    },
    updateAutomationSingleKey: async (automationId, key, value) => {
        return request
            .post(
                `/automation/${automationId}/single-key`,
                { key, value },
                {
                    timeout: 60 * 1000,
                }
            )
            .then((response) => response.data);
    },
    deleteMultiAutomations: async (ids) => {
        return request
            .post(
                `/automation/multi-delete`,
                { ids },
                {
                    timeout: 60 * 1000,
                }
            )
            .then((response) => response.data);
    },
    DESIGN: {
        addBlock: async (id, blockId, type) => {
            return request
                .put(
                    `/automation/design/${id}/b/${blockId}`,
                    { type },
                    {
                        timeout: 60 * 1000,
                    }
                )
                .then((response) => response.data);
        },
        deleteSingleBlock: async (id, blockId) => {
            return request
                .delete(`/automation/design/${id}/single/${blockId}`, {
                    timeout: 60 * 1000,
                })
                .then((response) => response.data);
        },
        deleteWithChildren: async (id, blockId) => {
            return request
                .delete(`/automation/design/${id}/recursive/${blockId}`, {
                    timeout: 60 * 1000,
                })
                .then((response) => response.data);
        },
        updateBlock: async (id, blockId, payload) => {
            return request
                .post(
                    `/automation/design/${id}/b/${blockId}`,
                    { payload },
                    {
                        timeout: 60 * 1000,
                    }
                )
                .then((response) => response.data);
        },
        copyBlock: async (id, blockId, targetBlockId) => {
            return request
                .post(
                    `/automation/design/${id}/b/${blockId}/copy`,
                    { targetBlockId },
                    {
                        timeout: 60 * 1000,
                    }
                )
                .then((response) => response.data);
        },
        moveBlock: async (id, blockId, targetBlockId) => {
            return request
                .post(
                    `/automation/design/${id}/b/${blockId}/move`,
                    { targetBlockId },
                    {
                        timeout: 60 * 1000,
                    }
                )
                .then((response) => response.data);
        },
    },
    PLAN: {
        list: async (filters, cursor, sort) => {
            return request
                .post(
                    `/automation/plans/history`,
                    {
                        filters,
                        cursor,
                        sort,
                    },
                    {
                        timeout: 60 * 1000,
                    }
                )
                .then((response) => response.data);
        },
    },
};
